import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {connect} from 'react-redux'
import Search from './Search'
import Items from './Items'
import {reduxForm, Field} from 'redux-form'
import {cancelTaxAssignToItem} from 'actions/library/tax'
import styles from './TaxAssignToItemModal.css'
import * as mpLibraryTax from 'mixpanel/library/tax'

// import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'

class TaxAssignToItemModal extends React.Component {
  render () {
    const {showTaxAssignToItemModal} = this.props
    return (
      <Modal show={showTaxAssignToItemModal} onHide={this._onHide} backdrop='static' dialogClassName={`modal-dialog ${styles.dialog}`}>
        <ModalHeader title={`Assign Items`} />
        <form onSubmit={this.props.handleSubmit}>
          {/* to help debugging easier, print form values */}
          <Field component='input' type='hidden' name='id' />
          <Field component='input' type='hidden' name='itemIds' />
          <Modal.Body bsClass={`${styles.body} modal-body`}>
            <Search />
            <Items />
          </Modal.Body>
          <Modal.Footer>
            <span className='pull-left'>
              {this._VisibleItemCount()}
            </span>
            <span className='pull-right'>
              <button className='btn btn-default' onClick={this._onHide}>Cancel</button>
              <button className='btn btn-primary'>Apply</button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }

  _onHide = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const {dispatch, taxDetail} = this.props
    if (taxDetail.id === null) {
      mpLibraryTax.libraryTaxCreateAssignItemCancel()
    } else {
      mpLibraryTax.libraryTaxEditAssignItemCancel()
    }
    dispatch(cancelTaxAssignToItem(taxDetail, ''))
  }

  _VisibleItemCount = () => {
    if (this.props.items !== undefined && this.props.taxAssignToItems !== undefined && this.props.items.length > 0) {
      return (<span>
        <b>1-{this.props.items.length}</b> of <b>{this.props.taxAssignToItems.totalCount}</b>
      </span>)
    }
  }
}

function mapStateToProps (state) {
  const {showTaxAssignToItemModal, categories, taxDetail} = state.library.tax
  const {taxAssignToItem} = state.form
  let taxAssignToItems = null // note plural...
  let items = []
  if (state.library.tax.taxAssignToItems !== undefined) {
    items = state.library.tax.taxAssignToItems.items
    taxAssignToItems = state.library.tax.taxAssignToItems
  }
  return {
    showTaxAssignToItemModal,
    taxAssignToItem,
    taxAssignToItems,
    items,
    categories,
    taxDetail
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'taxAssignToItem',
  keepDirtyOnReinitialize: false,
  enableReinitialize: true
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(TaxAssignToItemModal))



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxAssignToItemModal/TaxAssignToItemModal.js